import { createFileRoute } from '@tanstack/react-router'

// The leaf that makes the pathless `_window` layout match on the screen's own path; it renders nothing.
export const Route = createFileRoute('/_app/admin/metrics/endpoints/_window/')({})
